<div class="service-container">
  <div class="row">
    <div class="col">
    </div>
    <div class="col-6 content-price">
      <img src="assets/images/service.png">
    </div>
    <div class="col">
    </div>
  </div>
</div>
